export const clinics = ["Clinic 1", "Clinic 2", "Clinic 3"];

export const GREETING_VIDEO_YOUTUBE_ID = "wM0xN05PcRo";

export const loginOptions = ["SMS", "Email"];

export const DEFAULT_LOGO_URL =
  "https://mmk-public-files.s3.eu-central-1.amazonaws.com/AdGu-logo.png";

export const MAX_UPLOAD_FILE_SIZE = 100 * 1024 * 1024; // 100 MB

type DocumentCategory = {
  title: string;
  description: string;
  exampleDownloadLink: string;
};

export const DOCUMENTS_CATEGORIES: Record<string, DocumentCategory> = {
  weight: {
    title: "Gewichtsnachweise",
    description: `
        <p><strong>Wann?</strong> Einmal im Monat (etwa alle 30 Tage) während Ihrer Therapielaufzeit.<br>
        <strong>Wo?</strong> Bei Ihrem Hausarzt, in der Apotheke oder in Ihrem Adipositaszentrum.<br>
        <strong>Was?</strong> Lassen Sie sich wiegen und holen Sie sich einen schriftlichen Nachweis mit Ihrem
        Gewicht, dem Datum und einem Stempel (hierfür gibt es keinen Vordruck den Sie hier
        herunterladen können). Ihr Hausarzt, Ihre Apotheke oder Ihr Adipositaszentrum stellt Ihnen
        den Nachweis aus. <br>
        <strong>Dann?</strong> Machen Sie von jedem Nachweis ein Foto oder einen Scan und laden Sie es hier hoch.</p>
    `,
    exampleDownloadLink: "",
  },
  nutrition: {
    title: "Ernährungsprotokoll",
    description: `
        <p><strong>Wann?</strong> Für einmalig 2 Wochen durchgehend am Stück. Tipp: <strong>Erst zur Mitte Ihrer
Therapielaufzeit anfertigen,</strong> nachdem Sie bereits Informationen dazu sammeln konnten in
den monatlichen Terminen der Ernährungstherapie.<br>
        <strong>Wie?</strong> Klicken Sie auf „Vorlage Ernährungsprotokoll herunterladen“ und laden Sie die Vorlage
herunter. Drucken Sie die Vorlage aus oder füllen Sie diese digital aus. Tragen Sie dort jeden
Tag alles ein, was Sie essen und trinken.<br>
        Schreiben Sie jeden Tag auf, was Sie essen.<br>
        <strong>Dann?</strong> Machen Sie von den vollständig ausgefüllten Protokoll ein Foto oder einen Scan und laden Sie es hier hoch.</p>
    `,
    exampleDownloadLink:
      "https://mmk-public-files.s3.eu-central-1.amazonaws.com/upload-doc-example/nutrition-.pdf",
  },
  diet: {
    title: "Diätversuche-Protokoll",
    description: `
        <p><strong>Was?</strong> Schreiben Sie alle Diätversuche auf, die Sie in den letzten Jahren unternommen haben. Es müssen mindestens 6 Diätversuche dokumentiert werden.<br>
        <strong>Wie?</strong>Klicken Sie auf „Vorlage Diätversuche herunterladen“ und laden Sie die Vorlage herunter.<br>
        Drucken Sie die Vorlage aus.<br>
        <strong>Dann?</strong> Machen Sie von den vollständig ausgefüllten Protokoll ein Foto oder einen Scan und laden Sie es hier hoch.</p>
    `,
    exampleDownloadLink:
      "https://mmk-public-files.s3.eu-central-1.amazonaws.com/upload-doc-example/diet.pdf",
  },
  movement: {
    title: "Sportprotokoll",
    description: `
    <p>Vor einer Magen-OP verlangt der Medizinische Dienst (MD, früher MDK) einen Nachweis regelmäßiger Bewegung als Teil der konservativen Therapie (MMK).</p>
    <p>Ziel ist, dass Sie über mehrere Monate konsequent aktiv sind, also regelmäßig Sport treiben – ob allein, in einer Gruppe oder in einem Verein. Dies ist Grundlage für einen erfolgreichen OP-Verlauf und für die Kostenübernahme.</p>
    
    <h3>Sportprotokoll</h3>
    <p>Sie führen über Ihre sportliche Aktivität ein selbstgeführtes Sportprotokoll.</p>
    <p>&rarr; Laden Sie dazu unsere Vorlage herunter oder nutzen Sie die Ihres Adipositaszentrums.</p>
    <p>Wir prüfen das Protokoll auf Vollständigkeit und Plausibilität und nehmen es in Ihren MMK-Endbefund auf.</p>
    
    <h3>Anforderungen</h3>
    <ul>
      <li>Kurz, vollständig und nachvollziehbar</li>
      <li><strong>Dauer:</strong> Über die gesamte Therapielaufzeit<br>(z. B. bei 6 Monaten Programm → 6 Monate Protokoll; bei 3 Monaten → 3 Monate)</li>
      <li><strong>Richtwert:</strong> ca. 150 Minuten pro Woche, verteilt auf 2–5 Einheiten</li>
      <li><strong>Eintragung:</strong>
        <ul>
          <li>Wöchentlich Datum, Art der Aktivität und Dauer (in Minuten)</li>
          <li>Ausfälle (z. B. Krankheit): im Protokoll vermerken („krank“)</li>
          <li>→ keine „leeren“ Wochen; ggf. ärztliches Attest (optional)</li>
        </ul>
      </li>
      <li><strong>Abschluss:</strong><br>Am Ende vom Zeugen unterschreiben lassen<br>(Partnerin, Familienmitglied, Freundin, Nachbar*in etc.)</li>
    </ul>
    
    <h3>Was zählt als „Sport“?</h3>
    <p>Anerkannt wird gezielte körperliche Aktivität mit Trainingscharakter, die Ihre Ausdauer oder Kraft steigert – gelenkschonend beginnen und langsam steigern:</p>
    <ul>
      <li>Walking (zügig), Nordic Walking</li>
      <li>Schwimmen, Aquafitness, Aquajogging, Wassergymnastik</li>
      <li>Radfahren / Ergometer, Crosstrainer, moderates Laufband</li>
      <li>Fitnessstudio: Ausdauertraining + moderates Krafttraining (z. B. Gerätezirkel)</li>
      <li>Kurse, Rehasport oder Physiotherapie mit Bewegungsschwerpunkt</li>
      <li>Eigenübungen zu Hause (App, Video, Heimtrainer) → gut dokumentieren</li>
    </ul>
    <p><em><strong>Praxis-Tipp:</strong> Planen Sie feste Termine (z. B. Mo / Mi / Sa), damit Sie jede Woche sicher ca. 150 Minuten erreichen.</em></p>
    
    <h3>Was zählt nicht als Sport?</h3>
    <p>Nicht anerkannt werden Alltagsbewegungen ohne Trainingsziel oder passive Maßnahmen.</p>
    <ul>
      <li>Bummeln, Einkaufen, Hausarbeit, berufliches Stehen oder Gehen</li>
      <li>Normale Gassirunde mit dem Hund</li>
      <li>Massage, Sauna, Wellness</li>
      <li>Einzelaktionen ohne Plan oder Dokumentation</li>
    </ul>
    
    <h3>Optionale Zusatznachweise</h3>
    <p>Diese sind nicht verpflichtend, können aber bei manchen Kostenträgern die Akzeptanz erhöhen. Nutzen Sie möglichst Orte mit verlässlicher Anwesenheitsdokumentation:</p>
    <ul>
      <li>Fitnessstudio: Anwesenheitslisten, Ausdrucke, Trainer-Stempel</li>
      <li>Sportverein oder Kursleitung: z. B. Wassergymnastik, Walking-Gruppe, VHS-Kurse</li>
      <li>Physiotherapie/Rehasport: Teilnahme in geleiteten Gruppen</li>
      <li>Schwimmbad/Kurse: Teilnahmelisten</li>
      <li>Ärztin/Arzt oder Therapeut:in: betreutes Bewegungsprogramm</li>
      <li>Selbsthilfegruppe (SHG): mit Bewegungsangeboten</li>
      <li>Apps/Tracker: als ergänzender Nachweis</li>
    </ul>
    
    <h3>Abschluss</h3>
    <p>Am Ende Ihrer Therapielaufzeit:</p>
    <ul>
      <li>Sportprotokoll hochladen</li>
      <li>Wir vermerken das Sportprotokoll im MMK-Endbericht</li>
      <li>Den Endbericht reichen Sie bei Ihrem Adipositaszentrum oder Ihrer Klinik ein.</li>
    </ul>
    
    <h3>Download</h3>
    <p>Überschrift: Download</p>
    <p>Klicken Sie auf „Vorlage Sportprotokoll herunterladen“ und laden Sie die Vorlage herunter.</p>
    <p>Drucken Sie die Vorlage aus oder füllen Sie diese digital aus. Schreiben Sie auf, wann und welchen Sport Sie machen. Füllen Sie das Dokument vollständig aus. Lassen Sie Ihre/n Partner/in, einen Verwandten oder einen Freund unterschreiben.</p>
    <p>Machen Sie von dem vollständig ausgefüllten Protokoll ein Foto oder einen Scan und laden Sie es am Ende Ihrer Therapielaufzeit hier hoch.</p>
    `,
    exampleDownloadLink:
      "https://mmk-public-files.s3.eu-central-1.amazonaws.com/upload-doc-example/Sportprotokoll.pdf",
  },
  approval: {
    title: "Zustimmung zur MMK-Verkürzung",
    description: `
        <p>
        <strong>Wann?</strong> Einmalig<br>
        <strong>Wo?</strong> Bei ihrem Adipositaszentrum<br>
        <strong>Was?</strong> Lassen Sie sich die Bescheinigung ausfüllen und unterschreiben. Die Vorlage können Sie
        hier herunterladen und ausdrucken. Bitte unterstützen Sie das Adipositaszentrum dabei, da die
        Kolleginnen und Kollegen dort sehr viel zu tun haben. Über eine freundliche Nachricht von
        Ihnen werden sie sich dort bestimmt freuen.<br>
        <strong>Dann?</strong> Mach Sie von dem Nachweis ein Foto oder einen Scan und laden Sie es hier hoch.</p>
    `,
    exampleDownloadLink:
      "https://mmk-public-files.s3.eu-central-1.amazonaws.com/upload-doc-example/zustimmung.pdf",
  },
  medicalCetificateOfNecessity: {
    title: "Medizinische Notwendigkeitsbescheinigung",
    description: `
        <p>
        <strong>Wann?</strong> Einmalig<br>
        <strong>Wo?</strong> Bei Ihrem Hausarzt.<br>
        <strong>Was?</strong> Lassen Sie sich die medizinische Notwendigkeitsbescheinigung ausfüllen. Die Vorlage
        können Sie hier herunterladen und ausdrucken oder an Ihren Hausarzt versenden.<br>
        <strong>Dann?</strong> Mach Sie von dem Nachweis ein Foto oder einen Scan und laden Sie es hier hoch.</p>
    `,
    exampleDownloadLink:
      "https://mmk-public-files.s3.eu-central-1.amazonaws.com/upload-doc-example/notwendigkeitsbescheinigung.pdf",
  },
};

export const CLINIC_PREVIEW_ALERT_PARAGRAPHS = [
  "Disclaimer für den MMK-Bereich von adipositasgutachten.de",
  "Liebe Ärztinnen und Ärzte, liebe Fachbereichsleitungen,",
  "herzlich willkommen im MMK-Bereich von adipositasgutachten.de. Wir freuen uns, dass Sie sich die Zeit nehmen, unser Angebot zu erkunden.",
  "Bevor Sie sich weiter vertiefen, möchten wir einige wichtige Hinweise geben:",
  "Sie befinden sich derzeit in der ersten Version unseres MMK-Programms für Adipositas-Patienten. In den nächsten Wochen werden wir fortlaufend Inhalte und Funktionen ergänzen und optimieren. Unter anderem wird bald die Option bereitstehen, dass Patienten direkt über diese Plattform einen Beratungstermin mit unserem Ernährungsteam buchen können. Ihre Expertise ist für uns von größtem Wert. Daher bitten wir Sie um Ihre aktive Mithilfe. Wenn Sie Verbesserungsvorschläge, fachliche Anmerkungen oder sonstige Anregungen haben, kontaktieren Sie uns gerne unter kontakt@adipositasgutachten.de. Gemeinsam können wir ein optimal zugeschnittenes Angebot entwickeln, das Ihren Patientinnen und Patienten in bester Weise dient. Das Hauptanliegen unseres Engagements ist es, die Herausforderungen und Hürden Ihrer Patientinnen und Patienten auf ihrem Weg zu einem gesunden Leben mit einem gesunden Gewicht zu minimieren. Es ist unser Ansporn, dafür Sorge zu tragen, dass sie bestmöglich unterstützt und medizinisch fundiert beraten werden. Wir danken Ihnen für Ihr Vertrauen und Ihre Zusammenarbeit.",
  "Mit freundlichen Grüßen",
  "Robert Langmach",
];
